var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.36,32.69l-14.05-14.05c-1.8-1.8-4.25-2.81-6.79-2.81H27.22c-6.29,0-11.39,5.1-11.39,11.39v45.56c0,6.29,5.1,11.39,11.39,11.39h45.56c6.29,0,11.39-5.1,11.39-11.39v-33.3c0-2.55-1.01-4.99-2.81-6.79ZM48.5,23.49v3.8c0,2.1-1.7,3.79-3.79,3.79h-3.8c-2.1,0-3.79-1.7-3.79-3.79v-3.8h11.39ZM62.46,76.58h-12.46s0,0,0,0h-12.46v-15.19c0-2.1,1.7-3.79,3.79-3.79h17.34c2.1,0,3.79,1.7,3.79,3.79v15.19ZM76.58,50s0,0,0,0v22.78c0,2.1-1.7,3.8-3.8,3.8h-2.72v-15.19c0-6.29-5.1-11.39-11.39-11.39h-17.34c-6.29,0-11.39,5.1-11.39,11.39v15.19h-2.72c-2.1,0-3.8-1.7-3.8-3.8v-22.78s0,0,0,0v-22.78c0-2.1,1.7-3.8,3.8-3.8h2.29v3.87c0,6.29,5.1,11.39,11.39,11.39h3.8c6.29,0,11.39-5.1,11.39-11.39v-3.87h3.58c1.02,0,1.99.4,2.71,1.12l13.08,13.08c.72.72,1.12,1.69,1.12,2.71v9.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeSave);
export default __webpack_public_path__ + "static/media/acae_save.8da15580.svg";
export { ForwardRef as ReactComponent };